import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=506724c6&scoped=true&"
import script from "./page-not-found.vue?vue&type=script&lang=ts&"
export * from "./page-not-found.vue?vue&type=script&lang=ts&"
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=506724c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506724c6",
  null
  
)

export default component.exports